import Dexie from "dexie";

interface VideoChunk {
  id?: number;
  order: number;
  from: number;
  to: number;
  blob: Blob;
}

interface VideoMeta {
  id?: number;
  url: string;
  chunkCount: number;
  chunkSize: number;
}

export class VideoChunkDatabase extends Dexie {
  videoChunks?: Dexie.Table<VideoChunk, number>;
  meta?: Dexie.Table<VideoMeta, number>;

  constructor(dbName: string, version = 1) {
    super(dbName);
    this.version(version).stores({
      videoChunks: "++id,from, end, order, blob",
      meta: "++id,url,chunkCount,chunkSize"
    });
  }
}

export interface Chunk {
  blob: Blob;
  order: number;
  to: number;
  from: number;
}

export interface PdfChunks {
  url: string;
  eTag: string;
  chunkCount: number;
  chunkSize: number;
  chunks: Chunk[];
}

export class PdfChunkDatabase extends Dexie {
  private pdfChunks!: Dexie.Table<PdfChunks, string>;

  constructor(version = 1) {
    super("dex-pdf");
    this.version(version).stores({
      // & Unique index
      pdfChunks: "&url, etag, chunks"
    });
  }

  async put(pdfChunks: PdfChunks): Promise<void> {
    await this.pdfChunks.put(pdfChunks);
  }

  async get(url: string): Promise<PdfChunks | undefined> {
    // Oveření, že se jedná o validní URL
    const urlObj = new URL(url);
    return await this.pdfChunks.get(urlObj.href);
  }

  getAll(): Promise<PdfChunks[]> {
    return this.pdfChunks.toArray();
  }

  remove(url: string): Promise<void> {
    return this.pdfChunks.delete(url);
  }

  clear(): Promise<void> {
    return this.pdfChunks.clear();
  }
}
